import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const KeypadIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6 2C4.89543 2 4 2.89543 4 4C4 5.10457 4.89543 6 6 6C7.10457 6 8 5.10457 8 4C8 2.89543 7.10457 2 6 2Z"
      fill="currentColor"
    />
    <path
      d="M12 2C10.8954 2 10 2.89543 10 4C10 5.10457 10.8954 6 12 6C13.1046 6 14 5.10457 14 4C14 2.89543 13.1046 2 12 2Z"
      fill="currentColor"
    />
    <path
      d="M18 2C16.8954 2 16 2.89543 16 4C16 5.10457 16.8954 6 18 6C19.1046 6 20 5.10457 20 4C20 2.89543 19.1046 2 18 2Z"
      fill="currentColor"
    />
    <path
      d="M6 8C4.89543 8 4 8.89543 4 10C4 11.1046 4.89543 12 6 12C7.10457 12 8 11.1046 8 10C8 8.89543 7.10457 8 6 8Z"
      fill="currentColor"
    />
    <path
      d="M12 8C10.8954 8 10 8.89543 10 10C10 11.1046 10.8954 12 12 12C13.1046 12 14 11.1046 14 10C14 8.89543 13.1046 8 12 8Z"
      fill="currentColor"
    />
    <path
      d="M18 8C16.8954 8 16 8.89543 16 10C16 11.1046 16.8954 12 18 12C19.1046 12 20 11.1046 20 10C20 8.89543 19.1046 8 18 8Z"
      fill="currentColor"
    />
    <path
      d="M6 14C4.89543 14 4 14.8954 4 16C4 17.1046 4.89543 18 6 18C7.10457 18 8 17.1046 8 16C8 14.8954 7.10457 14 6 14Z"
      fill="currentColor"
    />
    <path
      d="M12 14C10.8954 14 10 14.8954 10 16C10 17.1046 10.8954 18 12 18C13.1046 18 14 17.1046 14 16C14 14.8954 13.1046 14 12 14Z"
      fill="currentColor"
    />
    <path
      d="M18 14C16.8954 14 16 14.8954 16 16C16 17.1046 16.8954 18 18 18C19.1046 18 20 17.1046 20 16C20 14.8954 19.1046 14 18 14Z"
      fill="currentColor"
    />
    <path
      d="M12 20C10.8954 20 10 20.8954 10 22C10 22.5523 10.4477 23 11 23H13C13.5523 23 14 22.5523 14 22C14 20.8954 13.1046 20 12 20Z"
      fill="currentColor"
    />
  </svg>
);

KeypadIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(KeypadIcon);
